/**
 * String utility functions for common text transformations
 */

/**
 * Converts a string to sentence case (first letter uppercase, rest lowercase)
 * @param input - The string to convert
 * @returns The string in sentence case, or empty string if input is falsy
 */
export function toSentenceCase(input: string): string {
  if (!input) return "";
  return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}

/**
 * Validates if a string is a valid email address format
 * @param email - The email string to validate
 * @returns True if the email format is valid, false otherwise
 */
export function isEmailValid(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
